import styled from 'styled-components';
import grey from 'sushiweb/tokens/color/grey';
import { P } from 'sushiweb/Typography/Text';
import Input from 'sushiweb/InputTypes/Input';

export const StyledP = styled(P)`
  font-size: 1.8rem;
  font-weight: 400;
  color: '#1C1C1C';
  margin-bottom: 1.5rem;
`;

export const CreateButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  padding: 5px 20px 20px 25px;
`;

export const FormWrapper = styled.div`
  margin-top: 1rem;
  border-top: 0.1rem solid ${grey.z200};
  padding: 2rem 2rem 0rem 2rem;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  p {
    font-size: 1.6rem;
    font-weight: 400;
    color: ${grey.z700};
  }
`;

export const DropdownWrapper = styled.div`
  padding: 5px 0px 25px 0px;
`;

export const DisabledInputWrapper = styled.div`
  padding: 5px 0px 10px 0px;
`;

export const InvoiceDetailsWrapper = styled.div`
  border-radius: 12px;
  background: var(--COOL-GREY-COOL-GREY50, #f8f9fc);
  padding: 12px;
  p {
    font-family: Lexend-300;
    font-size: 15px;
    color: var(--COOL-GREY-COOL-GREY600, #767c8f);
  }
`;

export const PayableAmountWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 5px;
`;

export const ActualPayableAmountWrapper = styled.div`
  padding-left: 5px;
`;

export const ActualPayableAmountForDiscountWrapper = styled.div`
  text-decoration: line-through;
`;

export const DiscountedPayaleAmountWrapper = styled.div`
  padding-left: 8px;
`;

export const DiscountedIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 5px;
`;

export const DiscountedIconText = styled.div`
  margin-left: -53px;
  padding-top: 1px;
  color: var(--color-base-white, #fff);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
`;

export const StyledInput = styled(Input)`
  width: 100%;
  font-weight: 300;
`;

export const AmountInput = styled(Input)`
  width: 100%;
  font-weight: 300;
  margin-top: 20px;
`;
